import { z } from 'zod';

const ApplyTagsToolCallArgumentsSchema = z.object({
  clipIds: z.array(z.string()).optional(),
  sourcePillIds: z.array(z.string()).optional(),
});

/** Reads targeted asset count from apply_tags toolCall args (backend: sourcePillIds). */
export const readApplyTagsToolCallAssetCount = (
  argumentsValue: Record<string, unknown> | undefined,
): number | undefined => {
  const parsed = ApplyTagsToolCallArgumentsSchema.safeParse(argumentsValue);

  if (!parsed.success) {
    return undefined;
  }

  const scopeIds = parsed.data.sourcePillIds ?? parsed.data.clipIds;

  if (!scopeIds) {
    return undefined;
  }

  return scopeIds.length;
};
